/**
 * 腾讯云 COS 实例 —— 通过 STS 临时密钥授权
 * 参考 kuguanjia-help/src/common/utils/cos.js
 *
 * SDK 每次需要签名时会自动调用 getAuthorization，
 * 这里向 /crm-biz/a/oss/upload/sign 换取临时密钥后回填给 SDK。
 */
import COS from 'cos-js-sdk-v5';
import { getUploadSign } from './mopRequest';

export default new COS({
  async getAuthorization(options, callback) {
    const pathArr = options.Scope[0].prefix.split('/');
    pathArr[pathArr.length - 1] = '*'; // 临时密钥按目录授权，如 home/*
    const { data } = await getUploadSign({
      bucketName: options.Bucket,
      regionName: options.Region,
      filePath: pathArr.join('/'),
    });
    callback({
      TmpSecretId: data.tmpSecretId,
      TmpSecretKey: data.tmpSecretKey,
      SecurityToken: data.sessionToken,
      StartTime: data.startTime, // 时间戳，单位秒
      ExpiredTime: data.expiredTime, // 时间戳，单位秒
    });
  },
});
